import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { environment } from '../environments/environment';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, SnackBarComponent, BreadcrumbComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.sass'
})
export class AppComponent implements OnInit {
  title = 'spa_iregistro';
  
  constructor() {

  }

  ngOnInit(): void {
    // ? Cargar NewRelic si está configurado
    if (environment.newRelic) {
      this.loadNewRelicScript(environment.newRelic);
    }
    
    // ? Cargar GTM si está configurado
    if (environment.gtmId) {
      this.loadGtmScript(environment.gtmId);
    }

    // ? Cargar GA4 si está configurado
    if (environment.ga4Id) {
      this.loadGa4Script(environment.ga4Id);
    }
  }

  private loadNewRelicScript(url: string) {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    document.head.appendChild(script);
  }

  // ? Carga dinámicamente el script de Google Tag Manager
  private loadGtmScript(gtmId: string) {
    // ? Snippet oficial de GTM sin script inline (permite una CSP sin 'unsafe-inline')
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
    document.head.appendChild(gtmScript);

    // ? Crear el noscript de GTM
    const gtmNoscript = document.createElement('noscript');
    const gtmIframe = document.createElement('iframe');
    gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    gtmIframe.height = '0';
    gtmIframe.width = '0';
    gtmIframe.style.display = 'none';
    gtmIframe.style.visibility = 'hidden';
    gtmNoscript.appendChild(gtmIframe);
    document.body.appendChild(gtmNoscript);
  }

  // ? Carga dinámicamente el script de Google Analytics 4
  private loadGa4Script(ga4Id: string) {
    // ? Crear el script principal de GA4
    const ga4MainScript = document.createElement('script');
    ga4MainScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4Id)}`;
    ga4MainScript.async = true;
    document.head.appendChild(ga4MainScript);

    // ? Configuración de GA4 sin script inline; gtag.js exige el objeto arguments, no un array
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.gtag = function () { w.dataLayer.push(arguments); };
    w.gtag('js', new Date());
    w.gtag('config', ga4Id);
  }
}